import React from 'react'

export default class ceoWord extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (
            <div className="container-fluid rtl">

                <h1 className="block-title text-center title mt-5">
                    كلمة المدير التنفيذي </h1>
                <div className="container  pb-5 my-5 ">
                    <div className="row ">

                        <div className="col-12 col-md-6 my-auto mx-auto">
                            <div className="grid">
                                <figure className="effect-sadie">
                                    <div className="ceo-img-container">
                                        <img src="https://i.ibb.co/f9s1j8x/lady-grey-suit-smiling-camera-background-stylish-cafe-with-lights.jpg" className="img-fluid" />
                                    </div>
                                    <figcaption>
                                        <h2>ندى <span>سعد</span> الدوس</h2>
                                        <p>المدير التنفيذي، CEO</p>
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 my-auto">
                            <p className="twenty-thirty-p text-justify">
                                الحياة محطات و مرافئ، نحتاج فيها إلى مرشد يرشدنا إلى جادة الطريق، وقد منَّ الرب علينا بافتتاح شركة هاد مرشد الأعمال التي تُعد مرآة أهدافنا، ورؤيتنا للمستقبل، إذ نقدم من خلالها كل ما حلمنا بتحقيقه من دعم لقطاع الأعمال، والتي نفخر بإنجازات روادها لتنعكس هذه النجاحات علينا، هاد هي مرشدنا ودليلنا معاً.

             </p>

                        </div>

                    </div>
                </div>
            </div>
        )
    }

}
